import LearnToPlayBlock from "components/learn-to-play/LearnToPlayBlock";
import { learnToPlayData } from "consts/learn-to-play";

const LearnToPlay = () => {
  return (
    <article className="privacy-page rules-page">
      <main className="privacy-page__main">
        <section className="privacy-page__block privacy-page__head">
          <h1 className="privacy-page__block-title">
            Learn to play: TwoTwentyK
          </h1>
        </section>
        {
          learnToPlayData.map((data) => <LearnToPlayBlock data={data} key={data.title} />)
        }
      </main>
    </article>
  );
};

export default LearnToPlay;
